// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e21d9e41","453":"f4f3c4e1","897":"61c8d3cb"}[chunkId] + ".chunk.js";
};